<ppl-two-factor-method-setup-common title="Email Address Verification"
                                    i18n-title="@@Email_Address_Verification"
                                    [step]="step"
                                    [methodType]="TwoFAType.EMAIL"
                                    [securityToken]="securityToken"
                                    [getSetupData]="getSetupData"
                                    [actionDisabled]="actionDisabled"
                                    (nextStep)="onNextStep($event)"
                                    (cancel)="onCancel()"
                                    (finish)="onFinish($event)"
                                    [formGroup]="form">
  <ppl-two-factor-method-setup-step title="Setup your email address..."
                                    i18n-title="@@Setup_your_email_address..."
                                    infoMessage="Coevera CRM will use this email address for your account security"
                                    i18n-infoMessage="@@Coevera_CRM_will_use_this_email_address_for_your_account_security">
    <ppl-input-container label="Enter the email address"
                         i18n-label="@@Enter_the_email_address"
                         [bold]="true"
                         pplFormControlName="email">
      <input pplInput
             type="email"
             autocomplete="email"
             formControlName="email"
             placeholder="Start typing..."
             i18n-placeholder="@@Start_typing..." />
    </ppl-input-container>
  </ppl-two-factor-method-setup-step>
</ppl-two-factor-method-setup-common>
